define('views/modules/calendar/animated-session/animation/rename/edit/custom-name-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/calendar/session/renamed-animation',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/calendar/animated-session/animation/rename/edit/custom-name-edit-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MRenamedAnimation,
    // views
    VBasePanel,
    VCustomNameEditContent
) {

    var VCustomNameEditPanel = VBasePanel.extend({
        header: {
            title: "calendar:Custom exercise names",
            subtitle: "calendar:Modify a custom exercise name",
        },
        buttons: { back: 'close' },
        tabs: [{ id: 'edit', title: 'Edit', icon: 'sl-icon-edit', active: true }],
        content: {
            edit: VCustomNameEditContent
        },
        defaultView: 'edit',
        initialize: function(opt) {
            this.model = new MRenamedAnimation();
            this.group = this.options.group;

            var edit = this.getView('edit', {
                model: this.model,
                group: this.group
            });

            this.listenTo(edit, { 'form:success': this.close });
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            this.model.fetch();
            return this;
        },

    });

    return VCustomNameEditPanel;
});

